import { TypographyColor } from 'melp-design/components';
import { CompanyStatus } from './companies.types';

export const COLOR_BY_STATUS: Record<CompanyStatus, TypographyColor> = {
  active: 'success',
  inactive: 'textSecondary',
};
